import { fork, takeLatest, all } from "redux-saga/effects";
import { LOGIN_BEGIN, AUTO_LOGIN } from "../actions/loginactions";
import { SIGN_UP_BEGIN } from "../actions/signupactions";
import { loginSaga, autoLoginSaga } from "./LoginSaga";
import { signUpSaga } from "./SignUpSaga";
import { VALIDATE_BEGIN } from "../actions/validateactions";
import { validateSaga } from "./ValidateSaga";
import { LOAD_BAND_INFO, SAVE_BAND_BEGIN } from "../actions/editbandactions";
import { loadBandSaga } from "./LoadBandSaga";
import { locationsSaga } from "./LocationsSaga";
import { LOAD_LOCATIONS_BEGIN } from "../actions/locationsactions";
import { saveBandSaga } from "./SaveBandSaga";
import { logoutSaga } from "./LogoutSaga";
import { LOGOUT_BEGIN } from "../actions/logoutactions";
import {
  DELETE_ACCOUNT_FINALISE_BEGIN,
  DELETE_ACCOUNT_PREPARE_BEGIN,
} from "../actions/deleteaccountactions";
import {
  FORGOTTEN_PASSWORD_BEGIN,
  FORGOTTEN_PASSWORD_RESET_BEGIN,
} from "../actions/forgottenpasswordactions";
import { forgottenPasswordSaga } from "./ForgottenPasswordSaga";
import { forgottenPasswordResetSaga } from "./ForgottenPasswordResetSaga";
import { resetPasswordSaga } from "./ResetPasswordSaga";
import { RESET_PASSWORD_BEGIN } from "../actions/resetpasswordactions";
import {
  LOAD_SONGS_BEGIN,
  SAVE_SONG_BEGIN,
  DELETE_SONG_BEGIN,
  SAVE_EVIDENCE_BEGIN,
  GET_REVIEW_STATES_BEGIN,
} from "../actions/songactions";
import { loadSongsSaga } from "./LoadSongsSaga";
import { saveSongSaga } from "./SaveSongSaga";
import { deleteSongSaga } from "./DeleteSongSaga";
import { deleteAccountPrepareSaga } from "./DeleteAccountPrepareSaga";
import { deleteAccountFinaliseSaga } from "./DeleteAccountFinaliseSaga";
import { saveEvidenceSaga } from "./SaveEvidenceSaga";
import { getReviewStatesSaga } from "./GetReviewStatesSaga";

export default function* rootSaga() {
  yield all([
    fork(watchLoginSaga),
    fork(watchAutoLoginSaga),
    fork(watchSignUpSaga),
    fork(watchValidateSaga),
    fork(watchLoadBandSaga),
    fork(watchLoadLocationsSaga),
    fork(watchSaveBand),
    fork(watchLogout),
    fork(watchForgottenPassword),
    fork(watchForgottenPasswordReset),
    fork(watchResetPasswordSaga),
    fork(watchLoadSongSaga),
    fork(watchSaveSongSaga),
    fork(watchDeleteSongSaga),
    fork(watchDeleteAccountPrepareSaga),
    fork(watchDeleteAccountFinaliseSaga),
    fork(watchSaveEvidenceSaga),
    fork(watchGetReviewStatesSaga)
  ]);
}

function* watchLoginSaga() {
  yield takeLatest(LOGIN_BEGIN, loginSaga);
}

function* watchAutoLoginSaga() {
  yield takeLatest(AUTO_LOGIN, autoLoginSaga);
}

function* watchSignUpSaga() {
  yield takeLatest(SIGN_UP_BEGIN, signUpSaga);
}

function* watchValidateSaga() {
  yield takeLatest(VALIDATE_BEGIN, validateSaga);
}

function* watchLoadBandSaga() {
  yield takeLatest(LOAD_BAND_INFO, loadBandSaga);
}

function* watchLoadLocationsSaga() {
  yield takeLatest(LOAD_LOCATIONS_BEGIN, locationsSaga);
}

function* watchSaveBand() {
  yield takeLatest(SAVE_BAND_BEGIN, saveBandSaga);
}

function* watchLogout() {
  yield takeLatest(LOGOUT_BEGIN, logoutSaga);
}

function* watchForgottenPassword() {
  yield takeLatest(FORGOTTEN_PASSWORD_BEGIN, forgottenPasswordSaga);
}

function* watchForgottenPasswordReset() {
  yield takeLatest(FORGOTTEN_PASSWORD_RESET_BEGIN, forgottenPasswordResetSaga);
}

function* watchResetPasswordSaga() {
  yield takeLatest(RESET_PASSWORD_BEGIN, resetPasswordSaga);
}

function* watchLoadSongSaga() {
  yield takeLatest(LOAD_SONGS_BEGIN, loadSongsSaga);
}

function* watchSaveSongSaga() {
  yield takeLatest(SAVE_SONG_BEGIN, saveSongSaga);
}

function* watchDeleteSongSaga() {
  yield takeLatest(DELETE_SONG_BEGIN, deleteSongSaga);
}

function* watchDeleteAccountPrepareSaga() {
  yield takeLatest(DELETE_ACCOUNT_PREPARE_BEGIN, deleteAccountPrepareSaga);
}

function* watchDeleteAccountFinaliseSaga() {
  yield takeLatest(DELETE_ACCOUNT_FINALISE_BEGIN, deleteAccountFinaliseSaga);
}

function* watchSaveEvidenceSaga() {
  yield takeLatest(SAVE_EVIDENCE_BEGIN, saveEvidenceSaga);
}

function* watchGetReviewStatesSaga() {
  yield takeLatest(GET_REVIEW_STATES_BEGIN, getReviewStatesSaga);
}
